'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VegetarianSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VegetarianSvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'fullimgVeg', width: width, height: height, viewBox: '0 0 25 27', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-full-vegetarian' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgVeg' },
            i18n.get('openrest_menubuilderv3_dishlabels_vegetarian') || 'vegetarian'
        ),
        _react2.default.createElement('path', {
            d: 'M22.9891174 12.93355913c.388996 0 .7369009.1461018 1.0081023.42460834.261157.2721146.3990406.61819322.3990406 1.00171043v3.9036573c0 .5140957-.2474599.951488-.6857653 1.226342-.576189.3762121-1.2172106.6711551-1.9048022.878437-.6875915.2054556-1.4044035.3104663-2.1303468.3104663-1.2573885 0-2.4280292-.3059006-3.4799621-.9103968-1.0510198-.6063224-1.8929314-1.4400158-2.5001669-2.4809911-.6044962-1.04097528-.91131-2.20065827-.91131-3.44800234 0-1.24643094.3068138-2.40702707.9122231-3.4489155.6063224-1.04006214 1.448234-1.8737555 2.4992538-2.47916482C17.2473168 7.30681377 18.4179575 7 19.675346 7c.6181933 0 1.2272551.06939835 1.8107492.20636878.5926254.14062298 1.1368545.35612313 1.6125985.63828222.220979.12966534.3944749.29676927.5177482.4994855.1260128.20728193.1899324.43921853.1899324.68941785 0 .38443035-.1369705.7314221-.3908223.99897102-.2638964.28672477-.6209326.44469734-1.0081024.44469734-.2556781 0-.50953-.06757207-.7350747-.19632428-.6528924-.29585613-1.3240475-.44561047-1.9970289-.44561047-.7222907 0-1.3888801.17714843-1.9805924.52596646-.5944517.34973118-1.0711088.83551965-1.4162743 1.4445815-.3460786.6127144-.5204876 1.29665343-.5204876 2.03355436 0 .73690092.174409 1.4171874.5204876 2.0225967.3442524.6044962.8218226 1.09302406 1.4199268 1.45006034.5880598.3515574 1.2564755.529619 1.9833319.529619.3524706 0 .7250301-.0420043 1.1076342-.1241865.2401548-.0502225.4574813-.1114027.6510661-.1798879v-1.76874482h-1.5048484c-.3844304 0-.7314221-.1387967-1.0017105-.39904053-.2785065-.26663577-.4255214-.6154538-.4255214-1.00992865 0-.40269307.1461018-.7560768.4264346-1.02819138.2739408-.26024382.6200195-.3981274 1.0007973-.3981274h3.0535275zM10.411415 7.1743177c.3837016 0 .720363.1260128 1.0072169.37895153.2951551.26298323.4519563.6072356.4519563.99531848 0 .1963243-.0451957.40177994-.1346646.6127144L7.25786675 19.6431927c-.13374218.281246-.33020482.5013118-.57555253.650153-.2342794.1451887-.50360845.2273709-.75910212.2310235h-.03320496l-.0322826-.0018263c-.26563962-.0191759-.50176373-.0995318-.72128536-.241068-.22136636-.1424492-.4039936-.3469917-.52851218-.5926254l-.01106832-.0210021-.00830123-.0219153L.12710303 9.1859568c-.08577947-.1707565-.12728566-.37347273-.12728566-.6200195 0-.41547698.16141297-.77251324.46948115-1.03914902.28777626-.2447205.61429163-.36982016.9684778-.36982016.3440402 0 .9712449.11779457 1.32543106.91587562l3.25039598 7.60642468L9.0767603 8.08654078l.01014596-.02648095.01291304-.02648095c.128208-.25659127.30437873-.4638732.52482273-.6154538.23335703-.15979884.50545317-.24380738.78677297-.24380738z',
            fill: primaryColor })
    );
}

VegetarianSvg.displayName = 'VegetarianSvg';
VegetarianSvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
VegetarianSvg.defaultProps = {
    width: 25,
    height: 27,
    primaryColor: '#a9c360'
};